import _ from "lodash";

export default {
    state: {
        list: [],
        count: null,
        filters: {
            search: "",
            orderBy: "codigo",
            desc: true,
            notUsed: false,
            date: {
                min: null,
                max: null
            },
            devices: [],
            advertising: [],
            deviceName: "",
            establishments: [],
            local: []
        }
    },

    mutations: {
        PROMOCIONALCODE_SET_LIST(state, list) {
            state.list = list;
        },

        PROMOCIONALCODE_SET_COUNT(state, count) {
            state.count = count;
        },

        PROMOCIONALCODE_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },

        PROMOCIONALCODE_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                orderBy: "codigo",
                desc: true,
                notUsed: false,
                date: {
                    min: null,
                    max: null
                },
                devices: [],
                advertising: [],
                deviceName: "",
                establishments: [],
                local: []
            };
        },

        SET_DEVICES(state, devices) {
            state.devices = devices;
        }
    },

    getters: {
        mappedDevicesPromocionalCode(state) {
            let devices = [];
            if (state.devices) {
                state.devices.forEach(function(item) {
                    devices.push(item);
                });
            }

            return _.map(devices, device => {
                return {
                    id: device.id,
                    label: device.nome
                };
            });
        }
    }
};
